import { SyncOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { useSyncData } from "~/compositions/state.js";
import { $t } from "~/i18n.js";

export const RefreshBaseData = ({ extra = null, loading = false, ...args }) => {
  
  const isPending = useSelector((state) => state?.flights?.isPending);

  const { sync } = useSyncData();

  async function syncData() {
    await sync();
    if (extra) extra();
  }

  return (
    <Button
      loading={loading || isPending}
      size="small"
      onClick={syncData}
      icon={<SyncOutlined />}
      {...args}
    >
      {$t("Sync")}
    </Button>
  );
};
